<template>
  <div class="   ">
    
      <!-- <p class="mrg4 fixed-bottom"> Copyright @ 2022 <a href="www.rentalect.com" > www.rentalect.com.</a> All Rights Reserved.</p> -->
      <div class="card-footer text-muted  color3 background_color shadow   bg-body rounded ">

  <nav class="row mrg4 ">
        <div class="col-md-2 mt-2">
         <h6 style="font-size: xx-small;">Copyright @ 2025. {{details[127]["All Rights Reserved"]}}.</h6> 
        </div>


        <div class="col-md-10" style="text-align: end;">
        <span class="mt-1 me-2" style="font-size: small;">{{details[25]["Powered by"]}}</span>
        <img src="./../../public/img/logo-issue-white.png" width="100px" alt="">
        </div>

  </nav>
      </div>


  </div>
  
</template>
<script>
import axios from 'axios';
import httpClient from '@/axios';

export default  {
data(){
return {

details:[],

}
},


created(){
  this.loadlanguage();
},

methods: {


  async loadlanguage() {

console.log(this.issue);

try {
  const { data} = await  httpClient.get('/web/api/user/loadlanguage',{
    headers:{
      // 'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   this.details = data.details;
  
   console.log(this.details);
   
  
} catch (error) {
  console.log(error.response);
}
},


 

},





}

</script>
<style scoped>
.card-footer{
  padding-left: 10px !important;
  padding-right: 10px !important;
  border-top: 0px solid #ECF7FF;
}
  .mrg4 {
    padding:0px ;
    }
    
    .link1{
      color: blue;
      cursor: pointer;
    }
   .color3{
    background-color: #fff;;
   }


   @media only screen and (max-width: 768px) {
    
   }
   
    
    
  
</style>